import {
  writable,
  type Writable,
} from 'svelte/store';

export const authUser: Writable<object> = writable(null);
export const authUserCollection: Writable<string[]> = writable([]);